import * as siteContextSelectors from './site-context.selectors'
import * as countrySelectors from './countries.selectors'
import * as currencySelectors from './currencies.selectors'

// eslint-disable-next-line @typescript-eslint/naming-convention
export const MbSiteContextSelectors = {
  ...siteContextSelectors,
  ...countrySelectors,
  ...currencySelectors
}
